import { render, staticRenderFns } from "./TeamPerformanceDetail.vue?vue&type=template&id=6c6d5180&scoped=true"
import script from "./TeamPerformanceDetail.vue?vue&type=script&lang=js"
export * from "./TeamPerformanceDetail.vue?vue&type=script&lang=js"
import style0 from "./TeamPerformanceDetail.vue?vue&type=style&index=0&id=6c6d5180&prod&lang=scss&scoped=true"
import style1 from "./TeamPerformanceDetail.vue?vue&type=style&index=1&id=6c6d5180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6d5180",
  null
  
)

export default component.exports